
























import 'nouislider/distribute/nouislider.css' # imported here so it's only done once

import TheIndexSlider from '@/components/TheIndexSlider'
import TheMoviesHolder from '@/components/TheMoviesHolder'
import TheTabs from '@/components/TheTabs'
import TheYearSlider from '@/components/TheYearSlider'

export default
    components: { TheIndexSlider, TheMoviesHolder, TheTabs, TheYearSlider }

    created: ->
        year = @$store.state.filter.range.year.upper_bound
        # @$store.dispatch 'settings_curation/loadSettings'
        @$store.dispatch 'data/loadMovies',
            year_from: year
            year_to: year-3
            votes_from: 999999999
            votes_to: 5000
            meta_info: true

